// Where the Essay Lab lives, and the one place that decides it.
//
// Two surfaces embed the lab now — the marking slide a learner writes in, and
// the saved-report viewer in My Learning Journey — and BOTH use this value
// twice over: once as the iframe `src`, and once as the origin they will accept
// messages from. A second copy that drifted would not fail loudly; it would
// silently drop every message, which is the most expensive failure mode this
// protocol has (see CLAUDE.md on lms-embed-event).
//
// Prod default is the deployed app; local dev points at the marking-coach dev
// server (the "Marking Coach (reference report)" launch.json entry, port 5199).

export const LAB_ORIGIN =
  (import.meta.env.VITE_ESSAY_LAB_ORIGIN as string | undefined) ??
  (import.meta.env.DEV ? 'http://localhost:5199' : 'https://essaylab.kulalearn.com');

/**
 * The lab, in show-me-this-report mode.
 *
 * `embed=1` is what turns the lab's embed seam on at all; `mode=report` is what
 * stops it being the marking app. Viewing takes no token and spends no marking —
 * the report is already marked and is posted in whole after the lab says it is
 * ready.
 */
export const LAB_REPORT_URL = `${LAB_ORIGIN}/?embed=1&mode=report`;
